import { Calendar } from 'lucide-react'
import { useMe } from '@/hooks/useMe'
import { format } from 'date-fns'
import { zhTW } from 'date-fns/locale'
import { useState } from 'react'
import { DashboardBookmarks } from '@/components/DashboardBookmarks'

export default function AdminHomePage() {
  const { user } = useMe()
  const [currentTime] = useState(new Date())

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h2 className="text-3xl font-bold tracking-tight">
            Hello, {user?.user_name || 'User'}
          </h2>
          <p className="text-sm text-muted-foreground">
            您好，歡迎使用日羿智能股份有限公司醫療管理平台
          </p>
        </div>
        <div className="flex items-center space-x-2 text-muted-foreground">
          <Calendar className="h-4 w-4" />
          <span className="text-sm">{format(currentTime, 'dd MMM, yyyy', { locale: zhTW })}</span>
        </div>
      </div>

      <DashboardBookmarks />
    </div>
  )
}
